import { captureException } from "@sentry/browser";
import React from "react";
import { ProductIdTypeEnum } from "__generated__/globalTypes";
import Layout from "components/common/Layout";
import ProductBundle, {
  PRODUCT_BUNDLE_VIEW_QUERY,
  ProductBundleParams,
  ProductBundleViewQuery,
  ProductBundleViewQueryVariables,
} from "components/courses/ProductBundle";
import { SeoPageProps } from "helpers/seo";
import { withEnhancedServerSideProps } from "helpers/withEnhancedProps";

function PackagePage({ seo }: SeoPageProps) {
  return (
    <Layout initialMeta={seo}>
      <ProductBundle />
    </Layout>
  );
}

export default PackagePage;

export const getServerSideProps = withEnhancedServerSideProps<SeoPageProps, ProductBundleParams>(
  async ctx => {
    try {
      if (ctx.isInitialRequest) {
        const { slug: id } = ctx.params || {};

        if (!id) throw new Error("Slug missing");

        const result = await ctx.apolloClient.query<
          ProductBundleViewQuery,
          ProductBundleViewQueryVariables
        >({
          query: PRODUCT_BUNDLE_VIEW_QUERY,
          variables: {
            id,
            idType: ProductIdTypeEnum.SLUG,
          },
        });

        return {
          props: {
            seo: result?.data?.product?.seo,
            title: result?.data?.product?.name || "",
          },
        };
      }
    } catch (err) {
      captureException(err);
      console.error(err);
      return { props: { title: "" }, notFound: true };
    }

    return { props: { title: "" } };
  }
);
